export enum GTMEventsEnum {
  ALERT_CREATED = 'alert_created',
  FILE_DOWNLOAD = 'file_download',
  PORTFOLIO_CREATED = 'portfolio_created',
  PROPERTY_ADDED_TO_PORTFOLIO = 'property_added_to_portfolio',
  PROPERTY_ADDED_TO_TRACKING = 'property_added_to_tracking',
  PROPERTY_REMOVED_FROM_TRACKING = 'property_removed_from_tracking',
  PROPERTY_DETAIL_VIEWED = 'property_detail_viewed',
  PROPERTY_SEARCH = 'property_search_used',
  PROPERTY_VIEWED = 'property_viewed',
  SIGN_IN = 'login',
  SIGN_UP = 'sign_up',
  SUBSCRIPTION_UPDATED = 'subscription_updated',
  SUBSCRIPTION_CANCELED = 'subscription_canceled',
}

export enum GTMSAuthEnum {
  EMAIL = 'email',
  FACEBOOK = 'facebook_auth',
  GOOGLE = 'google_auth',
}
